import Vue from 'vue'
import Vuex from 'vuex'
import {UserState, user} from "@/store/modules/user";

Vue.use(Vuex)

export default new Vuex.Store({
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user
  }
})


export interface RootState {
  user: UserState
}